export const SET_COMPANY_LOGO = "SET_COMPANY_LOGO";